import React from "react";
import styled from "styled-components";

const HeaderUserSubComponent = ({ user }) => {
  return (
    <Component>
      <Top>
        <p className="name">{user}</p> <p>Manage Profile</p>
      </Top>
      <Buttom>
        <Left>
          <p> Create a list</p>
          <p>find a list</p>
        </Left>
        <Right>
          <p> Account</p>
          <p> Orders</p>
          <p>Shipping Rates </p>
          <p>Recommendation</p>
          <p>Watchlist</p>
          <p>Matrix Assistant</p>
          <p>Sign Out</p>
        </Right>
      </Buttom>
    </Component>
  );
};

export default HeaderUserSubComponent;

const Component = styled.div`
  height: 100%;
  width: 100%;
  padding: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const Top = styled.div`
  height: 20px;
  width: 100%;
  font-size: 9px;
  border-bottom: 1px solid red;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 1px;
  .name {
    font-size: 12px;
    color: #14020d;
  }
`;

const Buttom = styled.div`
  display: flex;
  justify-content: space-between;

  width: 100%;
  p {
    line-height: 0px;
    font-size: 11px;
  }
  p:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
`;

const Right = styled.div`
  display: flex;
  flex-direction: column;
`;
